<template>

    <Panel>

        <PanelHeader heading="Post-Sale Settings" subheading="Configure what happens after the same" />

        <PanelBody>

            <Fieldset>
                <div class="min-w-0 flex-1 px-0 md:grid md:grid-cols-2 md:gap-6">
                    <div class="col-span-1" v-if="state.sale_form.fields.final_collection_unit_after.active && state.sale_form.fields.final_collection_number_after.active">
                        <legend class="block text-sm font-medium text-gray-700 mb-2">Collection Required By</legend>
                        <div class="min-w-0 flex-1 px-0 md:grid md:grid-cols-4 md:gap-2">
                            <div class="col-span-1">
                                <FormField :field="state.sale_form.fields.final_collection_number_after" namespace="sale_" :name="'final_collection_number_after'" class="mb-4" />
                            </div>
                            <div class="col-span-1">
                                <FormField :field="state.sale_form.fields.final_collection_unit_after" namespace="sale_" :name="'final_collection_unit_after'" class="mb-4" />
                            </div>
                            <div class="col-span-2">
                                <p class="mt-2 text-sm text-gray-500">After the sale ends</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Fieldset>

            <Fieldset>
                <div class="min-w-0 flex-1 px-0 md:grid md:grid-cols-2 md:gap-6">
                    <div class="col-span-1" v-if="state.sale_form.fields.final_payment_unit_after.active && state.sale_form.fields.final_payment_number_after.active">
                        <legend class="block text-sm font-medium text-gray-700 mb-2">Complete Payment Required By</legend>
                        <div class="min-w-0 flex-1 px-0 md:grid md:grid-cols-4 md:gap-2">
                            <div class="col-span-1">
                                <FormField :field="state.sale_form.fields.final_payment_number_after" namespace="sale_" :name="'final_payment_number_after'" class="mb-4" />
                            </div>
                            <div class="col-span-1">
                                <FormField :field="state.sale_form.fields.final_payment_unit_after" namespace="sale_" :name="'final_payment_unit_after'" class="mb-4" />
                            </div>
                            <div class="col-span-2">
                                <p class="mt-2 text-sm text-gray-500">After the sale ends</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Fieldset>

        </PanelBody>

        <PanelFooter>
            <Button type="button" width="w-auto" class="ml-2" :onClick="() => next_step()" :disabled="!next_button_active">Next</Button>
        </PanelFooter>

    </Panel>

</template>

<script>
import { useSaleStore } from '@sto/sale.store'
import { useSystemStore } from '@sto/system.store'
import { useAuthStore } from '@sto/auth.store'
import { computed, onMounted, onBeforeMount, reactive, watch } from 'vue'
import { isValid, getPayload, getUserOrganisationType } from '@lib/helpers'
import { useRoute, useRouter } from 'vue-router'
import config from '@/config'
import LoadingIcon from '@ico/LoadingIcon.vue'
import AuctioneerSelectLocation from "@par/auctioneer/AuctioneerSelectLocation.vue"
export default {
    components: {
        LoadingIcon,
        AuctioneerSelectLocation
    },
    setup() {
        const ROUTE = useRoute()
        const ROUTER = useRouter()
        const SALE_STORE = useSaleStore()
        const SYSTEM_STORE = useSystemStore()
        const AUTH_STORE = useAuthStore()

        const sale = computed(() => SALE_STORE.sale)

        const state = reactive({
            sale_form: {
                show_fields: false,
                valid: false,
                has_changes: computed(() => {
                    let has_changes = false
                    for (let f in state.sale_form.fields) {
                        if (state.sale_form.fields[f].value != state.sale_form.fields[f].stored_value) has_changes = true
                    }
                    return has_changes
                }),
                loading: false,
                fields: {
                    final_payment_unit_after: {
                        active: true,
                        label: '',
                        type: 'select',
                        value: sale.value?.final_payment_unit_after || (sale.value?.sale_type?.default_final_payment_unit_after || 'days'),
                        options: [
                            { value: 'days', label: 'Days' },
                            { value: 'hours', label: 'Hours' },
                        ],
                        stored_value: sale.value?.final_payment_unit_after || null,
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    final_payment_number_after: {
                        active: true,
                        label: '',
                        type: 'number',
                        value: sale.value?.final_payment_number_after || (sale.value?.sale_type?.default_final_payment_number_after || 3),
                        min_value: 1,
                        max_value: 100,
                        stored_value: sale.value?.final_payment_number_after || null,
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },

                    final_collection_unit_after: {
                        active: true,
                        label: '',
                        type: 'select',
                        value: sale.value?.final_collection_unit_after || (sale.value?.sale_type?.default_final_collection_unit_after || 'days'),
                        options: [
                            { value: 'days', label: 'Days' },
                            { value: 'hours', label: 'Hours' },
                        ],
                        stored_value: sale.value?.final_collection_unit_after || null,
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    final_collection_number_after: {
                        active: true,
                        label: '',
                        type: 'number',
                        value: sale.value?.final_collection_number_after || (sale.value?.sale_type?.default_final_collection_number_after || 9),
                        min_value: 1,
                        max_value: 100,
                        stored_value: sale.value?.final_collection_number_after || null,
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                }
            },
            ui: {
                fields: {

                }
            }
        })

        /**
         * should the next button be available to the user?
         */
        const next_button_active = computed(() => {
            let active = true
            for (let f in state.sale_form.fields) {
                if (state.sale_form.fields[f].active && state.sale_form.fields[f].required && !state.sale_form.fields[f].value) active = false
            }
            return active
        })

        const update_sale = async () => {

            if (state.sale_form.loading) return

            state.sale_form.loading = true

            if (!isValid(state.sale_form.fields)) {
                return state.sale_form.loading = false
            }

            const payload = getPayload(state.sale_form.fields)

            try {
                const sale = await SALE_STORE.updateSale(ROUTE.params.sale_id, payload)
                SALE_STORE.activateNextStep()

            } catch (error) {
                console.error('SALE_STORE.updateSale error', error)
                SYSTEM_STORE.addError('Something went wrong', error?.message || 'There was a problem updating the sale')

            } finally {
                state.sale_form.loading = false
            }
        }

        const next_step = async () => {
            await update_sale()
        }

        watch(
            () => [
                state.sale_form.fields.final_collection_number_after.value
            ],
            (new_value) => {
                state.sale_form.fields.final_collection_unit_after.options = [
                    { value: 'hours', label: new_value == 1 ? 'Hour' : 'Hours'},
                    { value: 'days', label: new_value == 1 ? 'Day' : 'Days'}
                ]
            }
        )

        watch(
            () => [
                state.sale_form.fields.final_payment_number_after.value
            ],
            (new_value) => {
                state.sale_form.fields.final_payment_unit_after.options = [
                    { value: 'hours', label: new_value == 1 ? 'Hour' : 'Hours'},
                    { value: 'days', label: new_value == 1 ? 'Day' : 'Days'}
                ]
            }
        )

        return {
            SALE_STORE,
            ROUTER,
            sale,
            next_button_active,
            state,
            next_step,
        }
    }
}

</script>

